import React, { useEffect, useState } from "react";
import classNames from "classnames/bind";
import PropTypes from "prop-types";
import { HeaderModal } from "../../../../components";
import empty from "../../../../assets/images/Emty.png";

import Filter from "./Filter";

import styles from "./ModalCamera.module.css";
import { OffStatus, OnStatus } from "../../../../components/Icons/Icons";
import NameCol from "../../../../components/NameCol";
import { sorterArray } from "../../../../utils";
import RenderStatus from "../../../../components/StatusRender";

const cx = classNames.bind(styles);
const ModalCamera = ({
  onClose,
  onOK,
  listCam,
  setCommune,
  setDistrict,
  setProvince,
  setNameCamera,
  setStatus,
}) => {
  const [dataSelect, setDataSelect] = useState([]);
  const [dataTable, setDataTable] = useState()
  const [toggleSort, setToggleSort] = useState(false)
  const [method, setMethod] = useState('')
  const [check, setCheck] = useState({})
  const companyCode = sessionStorage.getItem('company_code');
  const handleSelect = (e, item) =>   {
    setCheck({ ...check, [`${e.target.name}`]: e.target.checked });
    if (e.target.checked) {
      setDataSelect([...dataSelect, item]);
    } else {
      const data = dataSelect.filter(
        (data) => data?.CODE !== item?.CODE
      );
      setDataSelect(data);
    }
  };
  const handleAdd = () => {
    onOK(dataSelect);
    onClose();
  };


  useEffect(() => {
    const newData = listCam ? [...listCam] : null
    if (newData && method.length > 0) {
      switch (toggleSort) {
        case 'up':
          const dataSortUp = sorterArray(newData, method)
          setDataTable(dataSortUp)
          break;
        case 'down':
          const dataSortDown = sorterArray(newData, method)
          setDataTable(dataSortDown.reverse())
          break;
        default:
          setDataTable(newData)
          break;
      }
    } else {
      setDataTable(newData)
    }
  }, [listCam, toggleSort, method])

  const handleSort = (type, method) => {
    if (type !== toggleSort) {
      setToggleSort(type)
      setMethod(method)
    } else {
      setToggleSort(false)
      setMethod('')
    }
  }
  return (
    <div className={cx("content")}>
      <div className={cx("container")}>
        <>
          <HeaderModal title="Danh sách camera" onClose={onClose} />
          <Filter
            setCommune={setCommune}
            setDistrict={setDistrict}
            setNameCamera={setNameCamera}
            setProvince={setProvince}
            setStatus={setStatus}
          />
          <div className={cx("content-table")} style={{ padding: "0 16px" }}>
            {listCam.length > 0 ? (
              <table className={cx("table")}>
                <thead>
                  <tr>
                    <th>STT</th>
                    <th>
                      <NameCol active={method} title={'Tên camera'} handleSort={handleSort} method={'NAME_CAM'} />
                    </th>
                    <th>
                      <NameCol active={method} title={'Địa điểm'} handleSort={handleSort} method={'PROVINCE_NAME'} />
                    </th>
                    <th>
                      <NameCol active={method} title={'Công ty'} handleSort={handleSort} method={'WAREHOUSE_NAME'} />
                    </th>
                    <th style={{ textAlign: "center" }}>
                      Chọn {`(${dataSelect.length})`}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {dataTable &&
                    dataTable.length > 0 &&
                    dataTable.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>
                            <div style={{
                              display: "flex",
                              gap: 10,
                              alignItems: "center",
                              padding: "14px 0",
                            }}>
                              <span className={cx('On')}>
                                <RenderStatus  companyCode={companyCode} status={item.STATUS_ACTIVE}/>
                              </span>
                              <span style={{ fontSize: 14 }}>
                                {item?.NAME_CAM}
                              </span>
                            </div>
                          </td>
                          <td>{item?.PROVINCE_NAME}</td>
                          <td>{item?.WAREHOUSE_NAME}</td>
                          <td style={{ textAlign: "center" }}>
                            <input
                              checked={check ? check[`${item?.CODE}`] : false}
                              name={item?.CODE}
                              type="checkbox"
                              onChange={(e) => handleSelect(e, item)}
                            />
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            ) : (
              <div className={cx("content-faild")}>
                <img src={empty} alt="Không có nội dung tìm kiếm" />
                <p className={cx("description")}>Không có dữ liệu</p>
              </div>
            )}
          </div>
        </>
        <div className={cx("actions")}>
          <button onClick={handleAdd} className={cx("btn-add")}>
            Thêm mới
          </button>
          <button onClick={() => onClose()} className={cx("btn-cancel")}>
            Hủy bỏ
          </button>
        </div>
      </div>
    </div>
  );
};
ModalCamera.propTypes = {
  onClose: PropTypes.func,
  onOK: PropTypes.func,
  listCam: PropTypes.array,
};
export default ModalCamera;
